import React from 'react';

export const IconMainstays = () => {
  return (
    <svg
      style={{ verticalAlign: 'middle' }}
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6633 5.79933V5.79933C15.6633 5.36632 15.6633 5.14982 15.6299 4.96937C15.4792 4.1548 14.8418 3.51747 14.0273 3.36672C13.8468 3.33333 13.6303 3.33333 13.1973 3.33333H7.33331C5.44769 3.33333 4.50489 3.33333 3.9191 3.91911C3.33331 4.5049 3.33331 5.44771 3.33331 7.33333V7.85433C3.33331 9.44906 3.33331 10.2464 3.76219 10.7909C3.85983 10.9149 3.97179 11.0268 4.09574 11.1244C4.64021 11.5533 5.43758 11.5533 7.03231 11.5533V11.5533"
        stroke="white"
        strokeWidth="2"
      />
      <rect x="8.33331" y="8.33333" width="12.33" height="8.33" rx="2" stroke="white" strokeWidth="2" />
    </svg>
  );
};
